/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */

import { createReducer } from 'reduxsauce';
import { SlsInvSync01Types } from './Actions';
import INITIAL_STATE from './InitialState';

export const slsInvSync01ShowSyncSettingLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const slsInvSync01ShowSyncSettingSuccess = (state, { syncSetting }) => ({
  ...state,
  syncSetting
});

export const slsInvSync01ShowBatchJobStatusSuccess = (state, { batchJobStatus }) => ({
  ...state,
  batchJobStatus
});

export const slsInvSync01SyncLoading = (state, { boolean }) => ({
  ...state,
  syncIsLoading: boolean
});

export const slsInvSync01ResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now()
  // selectedDocuments: INITIAL_STATE.selectedDocuments
});

export const slsInvSync01FetchSlsInvSync01Loading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const slsInvSync01FetchSlsInvSync01Success = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const slsInvSync01AddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const slsInvSync01RemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const slsInvSync01SetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const slsInvSync01SyncNowSuccess = state => ({
  ...state,
  timestamp: Date.now(),
  selectedDocuments: []
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [SlsInvSync01Types.SLS_INV_SYNC01_SHOW_SYNC_SETTING_LOADING]: slsInvSync01ShowSyncSettingLoading,
  [SlsInvSync01Types.SLS_INV_SYNC01_SHOW_SYNC_SETTING_SUCCESS]: slsInvSync01ShowSyncSettingSuccess,
  [SlsInvSync01Types.SLS_INV_SYNC01_SHOW_BATCH_JOB_STATUS_SUCCESS]: slsInvSync01ShowBatchJobStatusSuccess,
  // [SlsInvSync01Types.SLS_INV_SYNC01_SYNC_LOADING]: slsInvSync01SyncLoading,

  [SlsInvSync01Types.SLS_INV_SYNC01_RESET_TIMESTAMP]: slsInvSync01ResetTimestamp,
  [SlsInvSync01Types.SLS_INV_SYNC01_FETCH_SLS_INV_SYNC01_LOADING]: slsInvSync01FetchSlsInvSync01Loading,
  [SlsInvSync01Types.SLS_INV_SYNC01_FETCH_SLS_INV_SYNC01_SUCCESS]: slsInvSync01FetchSlsInvSync01Success,
  [SlsInvSync01Types.SLS_INV_SYNC01_ADD_SELECTED_DOCUMENTS]: slsInvSync01AddSelectedDocuments,
  [SlsInvSync01Types.SLS_INV_SYNC01_REMOVE_SELECTED_DOCUMENTS]: slsInvSync01RemoveSelectedDocuments,
  [SlsInvSync01Types.SLS_INV_SYNC01_SET_WORKSPACE_VISIBLE]: slsInvSync01SetWorkspaceVisible,
  [SlsInvSync01Types.SLS_INV_SYNC01_SYNC_LOADING]: slsInvSync01SyncLoading,
  [SlsInvSync01Types.SLS_INV_SYNC01_SYNC_NOW_SUCCESS]: slsInvSync01SyncNowSuccess
});
